<app-navbar></app-navbar>

<!-- Hero Section -->
<section class="contact-hero-section">
  <div class="container">
    <div class="hero-content">
      <h1>Contactez-Nous</h1>
      <p class="hero-subtitle">Nous sommes là pour répondre à toutes vos questions et vous accompagner dans vos projets digitaux</p>
    </div>
  </div>
</section>

<!-- About Digital Alchemy Section -->
<section class="digital-alchemy-section">
  <div class="container">
    <div class="digital-alchemy-content">
      
      <!-- Left Column - Logo -->
      <div class="digital-alchemy-left">
        <div class="digital-alchemy-logo">
          <img src="assets/images/Logo-5.png" alt="Digital Alchemy Logo" />
        </div>
      </div>
      
      <!-- Right Column - Content -->
      <div class="digital-alchemy-right">
        <h2>
          <span class="brand-name">Digital Alchemy</span>, Votre Partenaire De Confiance Pour La Création De Sites Web
        </h2>
        
        <p class="description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web au Maroc et en France. Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <ul class="services-list">
          <li>
            <strong>Améliorez votre visibilité SEO :</strong> avec un Référencement Naturel de Haute Qualité pour booster votre classement sur Google.
          </li>
          <li>
            <strong>Créez un site performant :</strong> grâce à un <span class="highlight">Tarif Développement Site Web</span> compétitif et des solutions optimisées.
          </li>
          <li>
            <strong>Lancez un business en ligne :</strong> avec une boutique bien référencée et un <span class="highlight">E-commerce Optimisé</span>.
          </li>
          <li>
            <strong>Boostez vos conversions</strong> en appliquant des <span class="highlight">Stratégies Marketing</span> modernes et efficaces.
          </li>
          <li>
            <strong>Optimisez vos ventes :</strong> avec des stratégies de <span class="highlight">Marketing Digital</span> adaptées pour maximiser votre ROI.
          </li>
        </ul>
      </div>
      
    </div>
  </div>
</section>

<!-- Contact Information Cards -->
<section class="contact-info-section">
  <div class="container">
    <div class="contact-info-grid">
      
      <!-- Phone Card -->
      <div class="info-card">
        <div class="info-icon">
          <i>📞</i>
        </div>
        <h3>Téléphone</h3>
        <div class="info-details">
          <a href="tel:+212690459525">+212 690 459 525</a>
          <span class="info-label">Maroc</span>
        </div>
        <div class="info-details">
          <a href="tel:+33666076455">+33 6 66 07 64 55</a>
          <span class="info-label">France</span>
        </div>
      </div>
      
      <!-- Email Card -->
      <div class="info-card">
        <div class="info-icon">
          <i>📧</i>
        </div>
        <h3>Email</h3>
        <div class="info-details">
          <a href="mailto:Digitalalchemyma@gmail.com">Digitalalchemyma&#64;gmail.com</a>
        </div>
        <div class="info-details">
          <a href="mailto:Contact@digalchemy.com">Contact&#64;digalchemy.com</a>
        </div>
      </div>
      
      <!-- Address Card -->
      <div class="info-card">
        <div class="info-icon">
          <i>📍</i>
        </div>
        <h3>Notre Bureau au Maroc</h3>
        <div class="info-details">
          <p>5ème étage, N°27, Akram Offices</p>
          <p>Av. Arabie Saoudite, Agdal</p>
          <p>90000, Rabat</p>
        </div>
      </div>
      
    </div>
  </div>
</section>

<!-- Contact Form Section -->
<section class="contact-form-section">
  <div class="container">
    <div class="form-container">
      
      <div class="form-header">
        <h2>Un Projet En Tête ? Faites Une Demande De Devis</h2>
        <p>Remplissez le formulaire ci-dessous et notre équipe vous contactera dans les 24 heures</p>
      </div>
      
      <div class="form-wrapper">
        <!-- Form Steps Indicator -->
        <div class="form-steps">
          <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
            <div class="step-number">1</div>
            <div class="step-label">INFORMATIONS</div>
          </div>
          <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">
            <div class="step-number">2</div>
            <div class="step-label">SERVICE SOUHAITÉ</div>
          </div>
          <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">
            <div class="step-number">3</div>
            <div class="step-label">DÉTAILS</div>
          </div>
        </div>
        
        <!-- Success Message Alert -->
        <div *ngIf="submissionSuccess && !submissionError && !isSubmitting" class="success-alert">
          <div class="success-icon">✓</div>
          <div class="success-message">
            <strong>Demande envoyée avec succès!</strong>
            <br>Nous avons bien reçu votre demande de devis. 
            <br>Notre équipe vous contactera dans les 24 heures.
          </div>
        </div>

        <!-- Error Message Alert -->
        <div *ngIf="submissionError" class="error-alert">
          <div class="error-icon">!</div>
          <div class="error-message">{{ submissionError }}</div>
        </div>
        
        <!-- THE MAIN FORM -->
        <form class="contact-form" #contactForm="ngForm" (ngSubmit)="onSubmit()" *ngIf="!submissionSuccess">
          
          <!-- Step 1: Information -->
          <div *ngIf="currentStep === 1" class="form-step">
            <div class="form-row">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Nom et Prénom"
                [(ngModel)]="formData.name"
                name="name"
                #nameField="ngModel"
                required>
              
              <input 
                type="email" 
                class="form-control" 
                placeholder="Email"
                [(ngModel)]="formData.email"
                name="email"
                #emailField="ngModel"
                required
                email>
            </div>
            
            <div class="form-row">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Entreprise"
                [(ngModel)]="formData.company"
                name="company">
              
              <div class="select-wrapper">
                <select 
                  class="form-control"
                  [(ngModel)]="formData.employeeCount"
                  name="employeeCount">
                  <option value="" disabled selected>Nombre d'employés</option>
                  <option value="1-5">1-5 employés</option>
                  <option value="6-20">6-20 employés</option>
                  <option value="21-50">21-50 employés</option>
                  <option value="51+">51+ employés</option>
                </select>
              </div>
            </div>
            
            <div class="phone-row">
              <div class="country-code-selector">
                <div class="country-code" (click)="toggleCountryDropdown()">
                  <span class="flag">{{ selectedCountryCode.flag }}</span>
                  <span class="code">{{ selectedCountryCode.code }}</span>
                  <span class="arrow" [class.open]="showCountryDropdown">▼</span>
                </div>
                <div class="country-dropdown" *ngIf="showCountryDropdown">
                  <div 
                    *ngFor="let country of countryCodes"
                    class="country-option"
                    (click)="selectCountryCode(country)">
                    <span class="flag">{{ country.flag }}</span>
                    <span class="code">{{ country.code }}</span>
                    <span class="country-name">{{ country.country }}</span>
                  </div>
                </div>
              </div>
              <input 
                type="tel" 
                class="form-control" 
                placeholder="Téléphone"
                [(ngModel)]="formData.phone"
                name="phone">
            </div>
            
            <button type="button" class="suivant-button" (click)="nextStep()" [disabled]="!formData.name || !formData.email || !isValidEmail(formData.email)">
              Suivant
            </button>
          </div>

          <!-- Step 2: Services -->
          <div *ngIf="currentStep === 2" class="form-step">
            <div class="services-list">
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.webSite" name="webSite">
                <span class="checkmark"></span>
                Création de site web
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.seo" name="seo">
                <span class="checkmark"></span>
                Référencement SEO
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.advertising" name="advertising">
                <span class="checkmark"></span>
                Publicité en ligne
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.socialMedia" name="socialMedia">
                <span class="checkmark"></span>
                Gestion des réseaux sociaux
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.design" name="design">
                <span class="checkmark"></span>
                Design graphique
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.photo" name="photo">
                <span class="checkmark"></span>
                Photographie / Vidéographie
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.copywriting" name="copywriting">
                <span class="checkmark"></span>
                Copywriting
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.global" name="global">
                <span class="checkmark"></span>
                Accompagnement global
              </label>
              
              <label class="service-checkbox">
                <input type="checkbox" [(ngModel)]="formData.services.development" name="development">
                <span class="checkmark"></span>
                Développement d'application (web/mobile)
              </label>
            </div>
            
            <div class="select-wrapper budget-select">
              <select 
                class="form-control"
                [(ngModel)]="formData.budget"
                name="budget">
                <option value="" disabled selected>Budget</option>
                <option value="3500-10000">3 500 - 10 000 MAD</option>
                <option value="10000-25000">10 000 - 25 000 MAD</option>
                <option value="25000-50000">25 000 - 50 000 MAD</option>
                <option value="50000+">50 000+ MAD</option>
              </select>
            </div>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button type="button" class="suivant-button" (click)="nextStep()" [disabled]="!hasSelectedServices()">
                Suivant
              </button>
            </div>
          </div>

          <!-- Step 3: Details -->
          <div *ngIf="currentStep === 3" class="form-step">
            <input 
              type="text" 
              class="form-control" 
              placeholder="Sujet"
              [(ngModel)]="formData.subject"
              name="subject"
              required>
            
            <textarea 
              class="form-control textarea" 
              placeholder="Donnez nous plus de détails sur votre projet"
              [(ngModel)]="formData.details"
              name="details"
              rows="6"></textarea>
            
            <label class="terms-checkbox">
              <input 
                type="checkbox" 
                [(ngModel)]="formData.acceptTerms" 
                name="acceptTerms"
                required>
              <span class="checkmark"></span>
              En cochant cette case, vous acceptez notre <span class="link-text">Politique de Confidentialité</span> et <span class="link-text">Conditions Générales d'Utilisation</span>.
            </label>
            
            <div class="form-navigation">
              <button type="button" class="prev-button" (click)="previousStep()">
                Précédent
              </button>
              <button 
                type="submit" 
                class="suivant-button"
                [disabled]="!formData.acceptTerms || !formData.subject || isSubmitting"
                [class.button-loading]="isSubmitting">
                <span *ngIf="!isSubmitting">Envoyer la demande</span>
                <span *ngIf="isSubmitting" class="loading-spinner">Envoi en cours...</span>
              </button>
            </div>
          </div>
          
        </form>
        
        <!-- Success State -->
        <div *ngIf="submissionSuccess" class="success-state">
          <div class="success-content">
            <div class="success-icon-large">✓</div>
            <h3>Merci pour votre demande!</h3>
            <p>Nous avons bien reçu votre demande de devis et nous vous contacterons dans les 24 heures.</p>
            <button type="button" class="suivant-button" (click)="resetForm()">
              Nouvelle demande
            </button>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</section>

<!-- Map Section -->
<section class="map-section">
  <div class="container">
    <h2>Trouvez-Nous</h2>
    <div class="map-wrapper">
      <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3307.5842469844567!2d-6.838671!3d33.993618!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDU5JzM3LjAiTiA2wrA1MCcxOS4yIlc!5e0!3m2!1sen!2sma!4v1234567890"
        width="100%" 
        height="450" 
        style="border:0;" 
        allowfullscreen="" 
        loading="lazy">
      </iframe>
    </div>
  </div>
</section>



<footer class="footer-section">
  <div class="footer-container">
    
    <!-- Main Footer Content -->
    <div class="footer-content">
      
      <!-- Section 1: Company Logo & Description -->
      <div class="footer-company">
        <div class="company-logo">
          <img src="assets/images/logo-white.png" alt="Rhillane Logo" />
        </div>
        
        <p class="company-description">
          Digital Alchemy, votre partenaire de confiance pour la création de sites web . 
          Nous transformons vos idées en succès digital avec des solutions innovantes et performantes.
        </p>
        
        <!-- Social Media -->
        <div class="social-media-section">
          <ul style="display: flex; gap: 16px; list-style: none; padding: 0; margin: 0;">
            
            <!-- Facebook -->
            <li style="margin: 0;">
              <a href="https://www.facebook.com/people/Digital-alchemy/61565618420833" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Facebook page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1877F2; fill: #1877F2;" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </li>
            
            <!-- Behance -->
            <li style="margin: 0;">
              <a href="https://www.behance.net/digitalalchemy2" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Behance page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #1769FF; fill: #1769FF;" viewBox="0 0 24 24">
                  <path d="M0 4.4804V19.243h7.1554c.6613 0 1.3078-.0832 1.9297-.248.6288-.1654 1.1905-.4203 1.6792-.7661.485-.3431.8784-.7804 1.1677-1.3081.2862-.5258.4294-1.1471.4294-1.8641 0-.8784-.2067-1.6309-.6172-2.2506-.4073-.6172-.9897-1.0907-1.7494-1.4161.6388-.3431 1.1139-.8141 1.4285-1.4143.3146-.6002.4719-1.2755.4719-2.0274 0-.7193-.1327-1.3487-.4-1.8888-.2668-.5402-.6343-1.0033-1.0995-1.3914-.4652-.3881-.9712-.6884-1.5186-.8999C8.8135 4.5932 8.2071 4.4804 7.5446 4.4804H0zM15.3486 6.9795h4.7992v1.2755h-4.7992V6.9795zM3.2695 6.9795h3.8893c.9451 0 1.6612.2262 2.1463.6787.4851.4525.7277 1.0632.7277 1.8321 0 .8374-.2768 1.4676-.8323 1.8888-.5555.4212-1.2925.6323-2.2091.6323H3.2695V6.9795zM15.3486 13.2363h4.7992v1.2755h-4.7992v-1.2755zM3.2695 14.2834h4.3172c.6927 0 1.2944.1327 1.8051.3976.5107.2649.9378.6154 1.2755 1.0519.3377.4365.5849.9378.741 1.5044.1561.5666.2342 1.1543.2342 1.7632 0 .7193-.1014 1.3487-.3043 1.8888-.2029.5401-.5107.9949-.9237 1.3648-.4131.3699-.9378.6507-1.5743.8409-.6365.1902-1.3858.2853-2.2477.2853H3.2695v-7.0969z"/>
                </svg>
              </a>
            </li>
            
            <!-- LinkedIn -->
            <li style="margin: 0;">
              <a href="https://www.linkedin.com/company/digital-alchemy-ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our LinkedIn page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #0077B5; fill: #0077B5;" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </li>
            
            <!-- YouTube -->
            <li style="margin: 0;">
              <a href="https://www.youtube.com/@Digital_Alchemy_ma" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our YouTube page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #FF0000; fill: #FF0000;" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>
            </li>
            
            <!-- Instagram -->
            <li style="margin: 0;">
              <a href="https://www.instagram.com/digital_alchemy_ma/" 
                 target="_blank" 
                 rel="noopener noreferrer"
                 title="Visit our Instagram page"
                 style="width: 40px; height: 40px; background: #ffffff; border-radius: 50%; display: flex; align-items: center; justify-content: center; text-decoration: none; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);">
                <svg style="width: 20px; height: 20px; color: #E1306C; fill: #E1306C;" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
            </li>
            
          </ul>
        </div>
      </div>
      
      <!-- Section 2: Contact Information -->
      <div class="footer-contact">
        <h3 class="footer-title">CONTACT</h3>
        
        <div class="contact-info">
          <div class="contact-item">
            <span>+212 690 459 525</span>
          </div>
          <div class="contact-item">
            <span>+33 6 66 07 64 55</span>
          </div>
          <div class="contact-item">
            <span>Digitalalchemyma&#64;gmail.com</span>
          </div>
          <div class="contact-item">
            <span>Contact&#64;digalchemy.com</span>
          </div>
        </div>
        
        <div class="office-locations">
          <div class="office-item">
            <h4>NOTRE BUREAU AU MAROC</h4>
            <p>Bd Dammam, Technopark Casablanca , Maroc .</p>
          </div>
        </div>
      </div>
      
      <!-- Section 3: Services Column -->
      <div class="footer-links">
        <h3 class="footer-title">NOS SERVICES</h3>
        <ul class="footer-list">
          <li><a routerLink="/web">Sites Web</a></li>
<li><a routerLink="/appweb">Application Web</a></li>
          <li><a routerLink="/publicite">Publicité en ligne</a></li>
          <li><a routerLink="/gestion">Gestion des réseaux sociaux</a></li>
          <li><a routerLink="/design">Design Graphique</a></li>
          <li><a routerLink="/agence">Agence SEO</a></li>
        </ul>
      </div>
      
      <!-- Section 4: Quick Links Column -->
      <div class="footer-links">
        <h3 class="footer-title">LIENS RAPIDES</h3>
        <ul class="footer-list">
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/apropos">À propos</a></li>
          <li><a routerLink="/contact">Contact</a></li>
          <li><a routerLink="/cgu">Conditions Générales d'Utilisation</a></li>
          <li><a routerLink="/conf">Politique de Confidentialité</a></li>
        </ul>
      </div>
      
    </div>
    
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p class="copyright">
          © {{ currentYear }} Digital Alchemy. Tous droits réservés. | 
          <a routerLink="/cgu">Mentions légales</a> | 
          <a routerLink="/conf">Politique des cookies</a>
        </p>
        <div class="footer-bottom-links">
          <a routerLink="/contact">Support</a>
        </div>
      </div>
    </div>
    
  </div>
</footer>